// removed by extract-text-webpack-plugin
module.exports = {"AllocationStateButton":"StateButton__AllocationStateButton__3pwH7","AllocationStateButtonCurrent":"StateButton__AllocationStateButtonCurrent__3FRxI","checkIcon":"StateButton__checkIcon__PJyKD"};


//////////////////
// WEBPACK FOOTER
// ./src/components/StateButton/StateButton.css
// module id = 491
// module chunks = 0